"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CreateReviewFormResponse () {
        return CreateReviewFormResponse;
    },
    get DeleteReviewFormResponse () {
        return DeleteReviewFormResponse;
    },
    get GetCompanyReviewFormResponse () {
        return GetCompanyReviewFormResponse;
    },
    get GetCompanyReviewFormsResponse () {
        return GetCompanyReviewFormsResponse;
    },
    get GetReviewFormByBaseIdResponse () {
        return GetReviewFormByBaseIdResponse;
    },
    get GetReviewFormsResponse () {
        return GetReviewFormsResponse;
    },
    get PostCompanyReviewFormResponse () {
        return PostCompanyReviewFormResponse;
    },
    get UpdateReviewFormResponse () {
        return UpdateReviewFormResponse;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _reviewform = require("../../review-form");
const _reviewform1 = require("./review-form");
const PostCompanyReviewFormResponse = _zod.z.object({
    name: _zod.z.string(),
    _id: _utilsisomorphic.transformObjectId
});
const GetCompanyReviewFormsResponse = _zod.z.object({
    forms: _zod.z.array(_reviewform.CompanyReviewFormModel),
    total: _zod.z.number().min(0),
    page: _zod.z.number().min(0),
    limit: _zod.z.number().min(0)
});
const GetCompanyReviewFormResponse = _reviewform.CompanyReviewFormModel.omit({
    questionsCount: true,
    relatedWorkflowCount: true,
    relatedWorkflows: true
}).extend({
    questions: _zod.z.array(_models.ReviewQuestionModel),
    createdAt: _utilsisomorphic.transformDateToUTCString.nullish(),
    creator: _zod.z.object({
        name: _zod.z.string().default(""),
        _id: _utilsisomorphic.transformObjectId.nullable().default(null)
    }).nullish(),
    goalDiscussion: _zod.z.boolean().optional().default(false),
    goalCreation: _zod.z.boolean().optional().default(false)
});
const GetReviewFormsResponse = _zod.z.object({
    data: _zod.z.array(_reviewform1.ReviewFormWithoutQuestions),
    meta: _zod.z.object({
        success: _zod.z.literal(true),
        formsCount: _zod.z.number()
    })
});
const GetReviewFormByBaseIdResponse = _zod.z.object({
    data: _reviewform1.ReviewFormWithQuestions,
    meta: _zod.z.object({
        success: _zod.z.literal(true)
    })
});
const CreateReviewFormResponse = _zod.z.object({
    data: _reviewform1.ReviewFormWithQuestions,
    meta: _zod.z.object({
        success: _zod.z.literal(true)
    })
});
const UpdateReviewFormResponse = CreateReviewFormResponse;
const DeleteReviewFormResponse = _zod.z.object({
    meta: _zod.z.object({
        success: _zod.z.literal(true)
    })
});
